import { FieldErrors, FieldValues } from 'react-hook-form';

export const isSubmittedFieldValid = (fieldName: string, errors: FieldErrors<FieldValues>) => {
  return Object.keys(errors).length > 0 &&
    !Object.keys(errors).includes(fieldName)
}